import tw from 'tailwind-styled-components';

export const FallbackHeaderContainer = tw.div`
    text-center
`;

export const FallbackHeaderH1 = tw.h1`
    text-primary-100
    text-[32px]
    font-bold
`;

export const FallbackHeaderH2 = tw.h2`
    text-primary-100
    text-[24px]
    font-semibold
`;

export const FallbackHeaderH3= tw.h3`
    text-primary-100
    text-[16px]
    font-medium
`;

export const FallbackHeaderImg= tw.img`
    h-24
    block
    mx-auto
    my-4
`;